<template>
  <div class="login-view">
    <router-link to="/">
      <img src="../assets/logo.png" class="logo" alt width="160" height="52" />
    </router-link>
    <br />
    A mechanically theme card game.
    <div name="form-slide">
      <div class="form-container">
        <button @click.prevent="tempAccount">Just let me play</button>
        <p style="text-align: center; margin: 1.2rem auto;">- or -</p>
        <div class="error-box" v-if="error">
          <p>Something went wrong!</p>
          {{ error }}
        </div>
        <form @submit.prevent="authenticate">
          <p>Sign in to your account</p>
          <input
            type="text"
            placeholder="Username"
            style="width: 100%"
            v-model="username"
            required
          />
          <input
            type="text"
            placeholder="Token"
            style="width: 100%"
            v-model="token"
            required
          />
          <button type="submit">Sign in</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import store from "store";

export default {
  data: () => ({
    error: null,
    username: "",
    token: ""
  }),
  methods: {
    tempAccount() {
      this.$socket.emit("user.createTempAccount", err => {
        if (err) {
          this.error = error;
        } else {
          if (this.$route.name === "login") {
            this.$router.push("/");
          }
        }
      });
    },
    authenticate() {
      this.error = null;

      if (!this.username.trim().length) {
        return (this.error = "Please provide a username!");
      }
      if (!this.token.trim().length) {
        return (this.error = "Please provide a token!");
      }

      const credentials = {
        username: this.username.trim(),
        token: this.token.trim()
      };

      this.$socket.emit("user.authenticate", credentials, error => {
        console.log(error);
        if (error) {
          this.error = error;
        } else {
          store.set("user", credentials);

          if (this.$route.name === "login") {
            this.$router.push("/");
          }
        }
      });
    }
  }
};
</script>
<style>
.login-view {
  max-width: 500px;
  color: white;
  margin: 25px auto;
  position: relative;
  text-align: center;
}
.form-container {
  background: #a5b3ae;
  color: white;
  margin: 1rem auto;
  padding: 2.5rem 2rem;
  border-radius: 12px;
  padding-bottom: 3rem;
  transition: 0.5s all ease-in-out;
}
</style>
